import ManagingAssignedContents from './managing-assigned-contents';

export default ManagingAssignedContents;